var serialize = function (obj) {
	var str = [];
	for (var p in obj) {
		if (obj.hasOwnProperty(p)) {
			str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
		}
	}
	return str.join("&");
};

var handleLogin = function (ev) {
	ev.preventDefault();
	var evt = { "event": "user_login_attempt" }
	try {
		directGTMPush(evt);
	} catch (e) {
		console.error("Chyba pri directGTMPush", e);
	}
	try {
		directMeiroPush(evt);
	} catch (e) {
		console.error("Chyba pri directMeiroPush", e);
	}


	var fail_evt = { "event": "user_login_failed" }
	var succ_evt = { "event": "user_login_success" }

	var tgt = ev.currentTarget;
	var password_input = tgt.querySelector("input[name=password]");
	var email_input = tgt.querySelector("input[name=email]");
	if (email_input) {
		unmark_invalid(email_input);
	}
	unmark_invalid(password_input);

	var email = '';
	if (email_input) {
		email = email_input.value.trim();
	}
	var passwd = password_input.value;
	if (email_input && email === "") {
		mark_invalid(email_input);
		try {
			directGTMPush(fail_evt);
		} catch (e) {
			console.error("Chyba pri directGTMPush", e);
		}
		try {
			directMeiroPush(fail_evt);
		} catch (e) {
			console.error("Chyba pri directMeiroPush", e);
		}
		return false;
	}
	if (passwd === "") {
		password_input.parentNode.querySelector("small.invalid-feedback").innerHTML = password_input.dataset.missing;
		mark_invalid(password_input);
		try {
			directGTMPush(fail_evt);
		} catch (e) {
			console.error("Chyba pri directGTMPush", e);
		}
		try {
			directMeiroPush(fail_evt);
		} catch (e) {
			console.error("Chyba pri directMeiroPush", e);
		}
		return false;
	}
	var qry_args = {
		"email": email,
		"password": passwd
	};

	var req = new XMLHttpRequest();
	req.onreadystatechange = function () {
		// add loader before request
		if (req.readyState === XMLHttpRequest.OPENED) {
			document.body.classList.add("loading");
		} else if (req.readyState === XMLHttpRequest.DONE) {
			if (req.status === 200) {
				var req_data = JSON.parse(req.responseText);
				if (req_data["status"] === 200) {

					try {
						directGTMPush(succ_evt);
					} catch (e) {
						console.error("Chyba pri directGTMPush", e);
					}
					try {
						directMeiroPush(succ_evt);
					} catch (e) {
						console.error("Chyba pri directMeiroPush", e);
					}
					// loading nedáváme pryč ... protože se reloadne stránka
					reloadAfterLogin();
				} else {
					try {
						directGTMPush(fail_evt);
					} catch (e) {
						console.error("Chyba pri directGTMPush", e);
					}
					try {
						directMeiroPush(fail_evt);
					} catch (e) {
						console.error("Chyba pri directMeiroPush", e);
					}
					document.body.classList.remove("loading");
					password_input.parentNode.querySelector("small.invalid-feedback").innerHTML = req_data["status_message"];
					mark_invalid(password_input);
				}
			} else {
				try {
					directGTMPush(fail_evt);
				} catch (e) {
					console.error("Chyba pri directGTMPush", e);
				}
				try {
					directMeiroPush(fail_evt);
				} catch (e) {
					console.error("Chyba pri directMeiroPush", e);
				}
				document.body.classList.remove("loading");
				password_input.parentNode.querySelector("small.invalid-feedback").innerHTML = "Interní chyba systému. Prosím zkuste to později";
				mark_invalid(password_input);
			}
		}
	};

	req.open("POST", "/ajax/login", true);
	req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	req.send(serialize(qry_args));
	return false;
};

function reloadAfterLogin() {
	window.sessionStorage.loggedIn = true;
	// safe reload
	var loc = location.pathname + location.search;
	var allowedUri = [
		"/registrace",
		"/kosik/shrnuti",
		"/objednavka/overovani",
		"/confirm_registration"
	];

	if (allowedUri.includes(location.pathname)) {
		loc = "/moje";
	}
	location.href = location.protocol + '//' + location.host + loc;
}

var handleRegister = function (ev) {
	// TODO přepojit na globální funkci na kontrolu formulářů => tohle je chaos
	$('body').addClass('loading');
	var btnBig = $('.button.button--primary.button--big');
	btnBig.attr("disabled", true);

	ev.preventDefault();
	var tgt = ev.currentTarget;
	var method = tgt.dataset["method"];
	var email_input = tgt.querySelector("input[name=email]");
	var password_input = tgt.querySelector("input[name=password]");
	var password2_input = tgt.querySelector("input[name=password2]");
	var tos_input = tgt.querySelector("input[name=tos]");
	var cnc_accept_gdpr_register_input = tgt.querySelector("input[name=cnc_accept_gdpr_register]");
	var message_field = tgt.querySelector(".register_message");
	var shipping_address_input = tgt.querySelector("input[name=shipping_address]");
	var rdtk_register_as_library_input = tgt.querySelector("input[name=register_as_library]");
	var ico_input = tgt.querySelector("input[name=ico]");
	var phone_input = tgt.querySelector("input[name=ico]");

	unmark_invalid(email_input);
	unmark_invalid(password_input);
	unmark_invalid(password2_input);
	unmark_invalid(tos_input, ".custom-checkbox");
	// unmark_invalid(ico_input);
	// unmark_invalid(phone_input);
	if (cnc_accept_gdpr_register_input !== null) {
		unmark_invalid(cnc_accept_gdpr_register_input, ".custom-checkbox");
	}
	clear_message(message_field);

	var email = email_input.value.trim();
	var passwd = password_input.value;
	var passwd2 = password2_input.value;
	var refresh_target = tgt.dataset["target"];
	if (!refresh_target) {
		if (location.pathname == '/registrace') {
			refresh_target = "/";
		} else {
			refresh_target = location;
		}
	}

	var newsletter = tgt.querySelector("input[name=newsletter]");
	var tos = tos_input.checked;
	if (cnc_accept_gdpr_register_input !== null) {
		var cnc_accept_gdpr_register_exists = true;
		var cnc_accept_gdpr_register = cnc_accept_gdpr_register_input.checked;
	} else {
		var cnc_accept_gdpr_register_exists = false;
	}
	if (rdtk_register_as_library_input !== null) {
		var rdtk_register_as_library_exists = true;
		var rdtk_register_as_library = rdtk_register_as_library_input.checked;
	} else {
		var rdtk_register_as_library_exists = false;
	}

	var any_error = false;
	if (shipping_address_input !== null) {
		if (shipping_address_input.checked === true) {
			var shipping_name_input = tgt.querySelector("input[name=shipping_name]");
			var shipping_name = shipping_name_input.value;

			var shipping_surname_input = tgt.querySelector("input[name=shipping_surname]");
			var shipping_surname = shipping_surname_input.value;

			var shipping_phone_input = tgt.querySelector("input[name=shipping_phone]");
			var shipping_phone = shipping_phone_input.value;
			var shipping_phone_regexp = $(shipping_phone_input).data('regexp');
			var shipping_phone_format = RegExp(shipping_phone_regexp);

			var shipping_street_input = tgt.querySelector("input[name=shipping_street]");
			var shipping_street = shipping_street_input.value;

			var shipping_city_input = tgt.querySelector("input[name=shipping_city]");
			var shipping_city = shipping_city_input.value;

			var shipping_zip_input = tgt.querySelector("input[name=shipping_zip]");
			var shipping_zip = shipping_zip_input.value;
			var shipping_zip_regexp = $(shipping_zip_input).data('regexp');
			var shipping_zip_format = RegExp(shipping_zip_regexp);

			unmark_invalid(shipping_name_input);
			unmark_invalid(shipping_surname_input);
			unmark_invalid(shipping_phone_input);
			unmark_invalid(shipping_street_input);
			unmark_invalid(shipping_city_input);
			unmark_invalid(shipping_zip_input);

			if (shipping_name.length === 0) {
				mark_invalid(shipping_name_input);
				any_error = true;
			}

			if (shipping_surname.length === 0) {
				mark_invalid(shipping_surname_input);
				any_error = true;
			}

			if (shipping_phone.length === 0) {
				mark_invalid(shipping_phone_input);
				any_error = true;
			} else if (shipping_phone_format.test(shipping_phone) === false) {
				mark_invalid(shipping_phone_input);
				any_error = true;
			}

			if (shipping_street.length === 0) {
				mark_invalid(shipping_street_input);
				any_error = true;
			}

			if (shipping_city.length === 0) {
				mark_invalid(shipping_city_input);
				any_error = true;
			}

			if (shipping_zip.length === 0) {
				mark_invalid(shipping_zip_input);
				any_error = true;
			} else if (shipping_zip_format.test(shipping_zip) === false) {
				mark_invalid(shipping_zip_input);
				any_error = true;
			}
		}
	}

	if (passwd.length < 8) {
		mark_invalid(password_input);
		any_error = true;
	}
	if (passwd !== passwd2) {
		mark_invalid(password2_input);
		any_error = true;
	}
	if (email === "") {
		mark_invalid(email_input, undefined, "empty");
		any_error = true;
	}

	// vsechno predelano na div.formgroup
	// var group_checkbox = ".custom-checkbox";
	var group_checkbox = "div.form-group";

	if (!tos) {
		mark_invalid(tos_input, group_checkbox);
		any_error = true;
	}
	var use_address = tgt.querySelector("input[name=do_register]");

	if (use_address) {
		alert("Deprecation Warning: Form obasahuje input name=do_register => musí se změnit na 'address' a musí se upravit názvy polí pro adresní políčka");
	}
	if (cnc_accept_gdpr_register_exists && !cnc_accept_gdpr_register) {
		mark_invalid(cnc_accept_gdpr_register_input, group_checkbox);
		any_error = true;
	}
	if (rdtk_register_as_library_exists && rdtk_register_as_library) {
		var fact_company_inp = tgt.querySelector("input[name=facturation_company]");
		if (!fact_company_inp.value) {
			mark_invalid(fact_company_inp);
			any_error = true;
		}
		var fact_ic_inp = tgt.querySelector("input[name=facturation_ic]");
		var fact_ic_regexp = $(fact_ic_inp).data('regexp');
		var fact_ic_format = RegExp(fact_ic_regexp);
		if ((!fact_ic_inp.value) || (fact_ic_format.test(fact_company_inp.value) === false)) {
			mark_invalid(fact_ic_inp);
			any_error = true;
		}
	}

	var icoEl = tgt.querySelector("input[name=ico]");
	var company = tgt.querySelector("input[name=buy_company]");
	var phoneEl = tgt.querySelector("input[name=phone]");

	if (icoEl && !icoEl.dataset.valid) {
		any_error = true
		validateFormIco(icoEl, company.checked);
	}
	if (phoneEl && !phoneEl.dataset.valid) {
		any_error = true
		validateFormPhone(phoneEl, company.checked);
	}

	if (any_error) {
		$('body').removeClass('loading');
		btnBig.attr("disabled", false);
		scrollToElement($('.is-invalid:first'), -70);
		return false;
	}

	var url = "/ajax/register";
	if (method === "preregister") {
		url = "/ajax/preregister";
	}
	var req = new XMLHttpRequest();
	req.onreadystatechange = function () {
		if (req.readyState === XMLHttpRequest.DONE) {
			if (req.status === 200) {
				var req_data = JSON.parse(req.responseText);
				if (req_data["status"] === 200) {
					// safe reload
					window.sessionStorage.registeredIn = true;
					window.sessionStorage.sendRegisteredInEvent = true;
					$('body').removeClass('loading');
					location = refresh_target;
				} else if (req_data["status"] === 435) {
					$('body').removeClass('loading');
					btnBig.attr("disabled", false);
					mark_invalid(email_input, undefined, "exists");
					scrollToElement($('.is-invalid:first'), -70);
				} else if (req_data["status"] === 440) {
					$('body').removeClass('loading');
					btnBig.attr("disabled", false);
					mark_invalid(ico_input, undefined, "exists");
					scrollToElement($('.is-invalid:first'), -70);
				} else {
					$('body').removeClass('loading');
					btnBig.attr("disabled", false);
					show_message(message_field, req_data["status_message"], "danger");
				}
			} else {
				$('body').removeClass('loading');
				btnBig.attr("disabled", false);
				alert("Chyba");
			}
		}
	};

	req.open("POST", url, true);
	req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	req.send($(tgt).serialize());
	return false;
};

var handleResetPassword = function (ev) {
	ev.preventDefault();
	var tgt = ev.currentTarget;
	var email_input = tgt.querySelector("input[name=email]");
	var email = email_input.value;
	var message_field = tgt.querySelector(".forgotten_password_message");
	var portal = $.trim($('body').attr('class'));
	unmark_invalid(email_input);
	clear_message(message_field);

	if (email === "") {
		mark_invalid(email_input);
		return false;
	}

	var qry_args = {
		"email": email,
	};

	var req = new XMLHttpRequest();
	req.onreadystatechange = function () {
		if (req.readyState === XMLHttpRequest.DONE) {
			if (req.status === 200) {
				var req_data = JSON.parse(req.responseText);
				if (req_data["status"] === 200) {
					if (portal === 'tympanum') {
						show_message(message_field, "Na zadaný e-mail jsme odeslali instrukce pro resetování hesla. Pokud u nás účet s takovým e-mailem neexistuje, žádné instrukce nedorazí. V takovém případě bude nutné provést novou registraci.", "success");
					} else {
						show_message(message_field, "Na zadanou adresu jsme odeslali e-mail s možností obnovy hesla.", "success");
					}
				} else {
					show_message(message_field, "Neplatný e-mail", "danger");
				}
			} else {
				alert("Chyba");
			}
		}
	};

	req.open("POST", "/ajax/forgotten_password", true);
	req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	req.send(serialize(qry_args));
	return false;
};

var handleResetPasswordChange = function (ev) {
	ev.preventDefault();
	var tgt = ev.currentTarget;
	var hash = tgt.querySelector("input[name=hash]").value;
	var password_input = tgt.querySelector("input[name=password]");
	var passwd = password_input.value;
	var password2_input = tgt.querySelector("input[name=password2]");
	var passwd2 = password2_input.value;
	var refresh_target = tgt.dataset["target"];
	var message_field = tgt.querySelector(".forgotten_password_returned_message");
	if (!refresh_target) {
		refresh_target = location;
	}
	clear_message(message_field);
	unmark_invalid(password_input);
	unmark_invalid(password2_input);

	if (passwd.length < 8) {
		mark_invalid(password_input);
		return false;
	}
	if (passwd !== passwd2) {
		mark_invalid(password2_input);
		return false;
	}
	var qry_args = {
		"hash": hash,
		"password": passwd,
	}
	var req = new XMLHttpRequest();
	req.onreadystatechange = function () {
		if (req.readyState === XMLHttpRequest.DONE) {
			if (req.status === 200) {
				var req_data = JSON.parse(req.responseText);
				if (req_data["status"] === 200) {
					// safe reload
					location = refresh_target;
				} else {
					show_message(message_field, req_data["status_message"], "danger");
				}
			} else {
				alert("Chyba");
			}
		}
	};

	req.open("POST", "/ajax/forgotten_password_returned", true);
	req.setRequestHeader(
		"Content-type", "application/x-www-form-urlencoded");
	req.send(serialize(qry_args));
	return false;
};

var handleResendEmailConfirm = function (ev) {
	ev.preventDefault();
	var tgt = ev.currentTarget;
	var email_input = tgt.querySelector("input[name=email]");
	var email = email_input.value;
	var message_field = tgt.querySelector(".resend_confirmation_message");

	unmark_invalid(email_input);
	clear_message(message_field);

	if (email === "") {
		mark_invalid(email_input);
		return false;
	}
	var qry_args = {
		"email": email,
	};

	var req = new XMLHttpRequest();
	req.onreadystatechange = function () {
		if (req.readyState === XMLHttpRequest.DONE) {
			if (req.status === 200) {
				var req_data = JSON.parse(req.responseText);
				if (req_data["status"] === 200) {
					show_message(message_field, "Na zadanou adresu jsme odeslali e-mail s možností obnovy hesla.", "success");
				} else {
					show_message(message_field, req_data["status_message"], "danger");
				}
			} else {
				alert("Chyba");
			}
		}
	};

	req.open("POST", "/ajax/resend_confirmation", true);
	req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	req.send(serialize(qry_args));
	return false;
};

document.addEventListener("DOMContentLoaded", function (event) {
	var login_forms = document.querySelectorAll("form[name=login]");
	if (login_forms) {
		[].forEach.call(login_forms, function (item) {
			item.addEventListener("submit", handleLogin);

			// Přidání event listeneru na submit button pro zabránění uzavření dropdownu
			var submitButton = item.querySelector("button[type=button]");
			if (submitButton) {
				submitButton.addEventListener("click", function (e) {
					e.preventDefault();
					e.stopPropagation(); // Zabrání bublání eventu
					handleLogin({ preventDefault: function () { }, currentTarget: item });
				});
			}

			// Ošetření stisku Enter klávesy v login formuláři
			item.addEventListener("keydown", function (e) {
				if (e.key === "Enter" || e.keyCode === 13) {
					e.preventDefault();
					e.stopPropagation();
					handleLogin({ preventDefault: function () { }, currentTarget: item });
				}
			});
		});
	}

	var register_forms = document.querySelectorAll("form[name=register]");
	if (register_forms) {
		[].forEach.call(register_forms, function (item) {
			item.addEventListener("submit", handleRegister);
		});
	}

	var reset_forms = document.querySelectorAll("form[name=forgotten_password]");
	if (reset_forms) {
		[].forEach.call(reset_forms, function (item) {
			item.addEventListener("submit", handleResetPassword);
		});
	}

	var reset_return_forms = document.querySelectorAll("form[name=forgotten_password_returned]");
	if (reset_return_forms) {
		[].forEach.call(reset_return_forms, function (item) {
			item.addEventListener("submit", handleResetPasswordChange);
		});
	}

	var reset_confirm_forms = document.querySelectorAll("form[name=resend_confirmation]");
	if (reset_confirm_forms) {
		[].forEach.call(reset_confirm_forms, function (item) {
			item.addEventListener("submit", handleResendEmailConfirm);
		});
	}

	var login_js_forms = document.querySelectorAll(".js-login-form");
	if (login_js_forms) {
		[].forEach.call(login_js_forms, function (form) {
			var submitButton = form.querySelector(".js-login-submit");
			if (submitButton) {
				submitButton.addEventListener("click", function (ev) {
					ev.preventDefault();
					handleLogin({ currentTarget: form });
				});
			}
		});
	}

	// Zabránění uzavření dropdownu při kliknutí dovnitř login formu
	var loginDropdowns = document.querySelectorAll('.dropdown-menu--login');
	if (loginDropdowns) {
		[].forEach.call(loginDropdowns, function (dropdown) {
			dropdown.addEventListener('click', function (e) {
				e.stopPropagation();
			});
		});
	}
});

function addressChangedInPopupCart(
	addressId, addressType, formData, forceServerCheck
) {
	var form = $('.js--' + addressType + '_address .address__label');
	delete formData["address_type"];
	delete formData["address_id"];
	var html = [];

	$.each(formData, function (index) {
		var value = '';
		if (index === 'country') {
			var name_val = $("select[name=" + addressType + "_country] option:selected");
			if (name_val) {
				value = name_val[0].text;
			}
			if (!value) {
				value = formData[index];
			}
			if (value === 'CZ') {
				value = 'Česká republika';
			} else if (value === 'SK') {
				value = 'Slovenská republika';
			}
			if (typeof actualize_shipping_payment !== 'undefined') {
				if (!forceServerCheck) {
					old_value = $(form).find(".address__label--" + index);
					if (old_value && old_value.length) {
						old_value = old_value[0].textContent;
						forceServerCheck = (old_value && old_value.trim() != value)
					}
				}
				if (forceServerCheck) {
					// změna země znamená aktulizaci košíku
					$.ajax({
						isLocal: true,
						method: "GET",
						dataType: "json",
						url: "/actualize-cart-on-address-change?type=" + addressType + "&address_id=" + addressId,
						success: function (response) {
							if (response["status"] === 500) {
								console.log(response["message"]);
							} else {
								actualize_shipping_payment("address-logged", response["mini_checkout"], response["pricing"], response["payment_options"], response["shipping_options"]);
							}
						}
					});
				}
			}

		} else {
			value = formData[index]
		}
		var sep = (index === 'name' || index === 'city') ? '&nbsp;' : '<br />';

		html.push("<span class='address__label--" + index + "'>" + value + "</span>" + sep);
	});

	$(form).html(html.join(''));
}

$(function () {
	$('a.login-cart.button, #payment_form button.login_modal').on('click', function (ev) {
		$('#modal_login').modal('show');
	});
});
